export const PERMISSION_CATEGORIES = [
  'vessel',
  'users',
  'menu',
  'activity',
  'communication',
  'service-provider',
  'wallet',
  'document',
  'logbook',
] as const;

export type PermissionCategory = (typeof PERMISSION_CATEGORIES)[number];

export const PERMISSIONS = {
  vessel: {
    GetVesselInfo: 'GetVesselInfo',
    CreateVessel: 'CreateVessel',
    EditVesselInfo: 'EditVesselInfo',
    TransferVessel: 'TransferVessel',
    DeleteVessel: 'DeleteVessel',
    Equipment: 'Equipment',
    ChefNote: 'ChefNote',
    GetMarinaInfo: 'GetMarinaInfo',
    MarinaBooking: 'MarinaBooking',
    Recipe: 'Recipe',
    EditSafetyInfo: 'EditSafetyInfo',
    ManagePermissions: 'ManagePermissions',
    /** Create, edit and remove this vessel's job postings — owner and captain. */
    JobAds: 'JobAds',
    /** Read job postings and apply to them — every account holds it. */
    GetJobAds: 'GetJobAds',
  },
  users: {
    CrewManagement: 'CrewManagement',
    InviteUser: 'InviteUser',
  },
  menu: {
    GetMenuInfo: 'GetMenuInfo',
    MenuChangeRequest: 'MenuChangeRequest',
    EditMenu: 'EditMenu',
  },
  activity: {
    Tasks: 'Tasks',
    ExternalTasks: 'ExternalTasks',
    GetEventsInfo: 'GetEventsInfo',
    EventsActions: 'EventsActions',
    GuestEvents: 'GuestEvents',
    InternalGallery: 'InternalGallery',
    ExternalGallery: 'ExternalGallery',
    Maintenance: 'Maintenance',
    Projects: 'Projects',
  },
  communication: {
    Folders: 'Folders',
    Notifications: 'Notifications',
    RoomsBasic: 'RoomsBasic',
    RoomsExport: 'RoomsExport',
    RoomsAll: 'RoomsAll',
    RoomsInternal: 'RoomsInternal',
    RoomsTemporary: 'RoomsTemporary',
    MessagesAll: 'MessagesAll',
    CrewChatMessages: 'CrewChatMessages',
  },
  'service-provider': {
    BasicServiceProvider: 'BasicServiceProvider',
    ServiceProviderInternal: 'ServiceProviderInternal',
    Ports: 'Ports',
  },
  wallet: {
    TransactionsBasic: 'TransactionsBasic',
    Transactions: 'Transactions',
    Invoices: 'Invoices',
    Quotes: 'Quotes',
    Payments: 'Payments',
    VendorMappings: 'VendorMappings',
    GetBudgets: 'GetBudgets',
    EditBudgets: 'EditBudgets',
    FinancialFolder: 'FinancialFolder',
  },
  document: {
    DocumentBasic: 'DocumentBasic',
    DocumentPrivate: 'DocumentPrivate',
    OperationalContentFolderRead: 'OperationalContentFolderRead',
    OperationalContentFolderWrite: 'OperationalContentFolderWrite',
    SafetyContentFolderRead: 'SafetyContentFolderRead',
    SafetyContentFolderWrite: 'SafetyContentFolderWrite',
    GeneralInformationFolderRead: 'GeneralInformationFolderRead',
    GeneralInformationFolderWrite: 'GeneralInformationFolderWrite',
    MarinaFolder: 'MarinaFolder',
    SharedFolder: 'SharedFolder',
    LogsFolder: 'LogsFolder',
    DailyFolder: 'DailyFolder',
  },
  logbook: {
    DailyLog: 'DailyLog',
    DailyLogSignCaptain: 'DailyLogSignCaptain',
    DailyLogSignMate: 'DailyLogSignMate',
    DailyLogDelete: 'DailyLogDelete',
    DigitalNavigationLog: 'DigitalNavigationLog',
    DigitalNavigationLogDelete: 'DigitalNavigationLogDelete',
    TrashLog: 'TrashLog',
    TrashLogSign: 'TrashLogSign',
    TrashLogDelete: 'TrashLogDelete',
    SafetyLog: 'SafetyLog',
    SafetyLogSign: 'SafetyLogSign',
    SafetyLogDelete: 'SafetyLogDelete',
    OilLog: 'OilLog',
    OilLogDelete: 'OilLogDelete',
  },
} as const;

type Cat = typeof PERMISSIONS;
export type Permission = { [K in keyof Cat]: Cat[K][keyof Cat[K]] }[keyof Cat];
